module.exports = __webpack_public_path__ + "img/logo-outline.1c41f4de.svg";